class VideoWrapper extends HTMLElement {
  constructor() {
    super();
    this.isAsync = false;
    this.hasLoaded = false;
  }

  playVideo() {
    let player = this.video.node;
    if (!player) return;
    
    if (!this.hasLoaded) {
      player.load();
      this.hasLoaded = true;
    }

    this.pauseOtherWrappers();
    player.play();
    this.setAttribute("video-state", "playing");
  }

  pauseVideo() {
    let player = this.video.node;
    if (!player) return;
    
    player.pause();
  }

  pauseOtherWrappers() {
    document.body.dispatchEvent(new CustomEvent("video-wrappers:pause", {
      bubbles: true,
      detail: {
        origin: this,
      }
    }))
  }

  asyncLoading() {
    if (!this.video.sources) return;
    this.video.sources.forEach(src => {
      let dataSrc = src.dataset.src;
      if (dataSrc) src.setAttribute("src", dataSrc);
    });
  }

  init() {
    this.video = {
      node: this.querySelector("video"),
    }

    if (this.video.node) {
      this.video.sources = this.video.node.querySelectorAll("source");

      // Look a data-src is present on the <source>'s
      if (this.video.sources.length > 0) {
        this.isAsync = !!Array.from(this.video.sources).find(src => src.dataset.src);
      }
    }
  }

  observeIntersection() {
    let callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!this.hasLoaded) {
            this.asyncLoading();
          }
          
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      })
    };
    
    let observer = new IntersectionObserver(callback, {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    });

    observer.observe(this);
  }

  connectedCallback() {
    this.init();
    this.observeIntersection();
    document.body.addEventListener("video-wrappers:pause", (e) => {
      if (e.detail.origin !== this) {
        this.pauseVideo();
      }
    });
  }
}

customElements.define("video-wrapper", VideoWrapper);